import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Defaults used until Shopify pricing loads (avoid layout flash / blocking UI).
const DEFAULTS = {
  main: { price: 12.9, compare_at: 29.9 },
  upsell: { price: 4.99, compare_at: 15.99 },
  currency: "EUR",
};

export const fmtPrice = (n) => `€${Number(n).toFixed(2).replace(".", ",")}`;

let cache = null;

export function usePricing() {
  const [pricing, setPricing] = useState(cache || DEFAULTS);

  useEffect(() => {
    if (cache) return;
    let active = true;
    axios
      .get(`${API}/shopify/products`)
      .then(({ data }) => {
        if (!active) return;
        const merged = {
          main: { ...DEFAULTS.main, ...data.main },
          upsell: { ...DEFAULTS.upsell, ...data.upsell },
          currency: data.currency || "EUR",
        };
        cache = merged;
        setPricing(merged);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return pricing;
}
